import { Component } from "react";
import App from "../App";
import validator from "validator";
import firebase from "../firebase";

export const setCurrentPage = (refObj: Component, currentPage: string) => {
  refObj.setState({ currentPage: currentPage, tryLogin: false });
};

export const getDefaultAppState = () => {
  return {
    name: "Anonymous",
    yob: 2000,
    mob: "",
    school: "",
    croom: "",
    gender: "",
    phoneNo: "",
    email: "",
    language: "",
    origin: "",
    mt: "",
    currentPage: "home",
    isSubProvider: true,
    isLoggedIn: !!firebase.auth().currentUser ? true : false,
    tryLogin: false,
    yobError: "",
    mobError: "",
    schoolError: "",
    croomError: "",
    phoneNoError: "",
    emailError: "",
    genderError: "",
    originError: "",
    mtError: "",
    isExistingSubject: false,
    metaDataAvailable: false,
    providerId: !!firebase.auth().currentUser
      ? firebase.auth().currentUser?.uid
      : "Anonymous",
    subjectId: "",
    langDocFirestore: "",
    docs: null,
    showModal: true,
    anonId: "",
    identification: false,
    identification_file: new Blob(),
  };
};

const validate = (appObj: App) => {
  let yobError = "";
  let mobError = "";
  let schoolError = "";
  let croomError = "";
  let phoneNoError = "";
  let emailError = "";
  let genderError = "";
  let originError = "";
  let mtError = "";
  //let langError = "";
  if (appObj.state.origin === "") {
    originError = "Select the state of origin";
  }
  if (appObj.state.mt === "") {
    mtError = "Select the native language";
  }
  if (appObj.state.yob <= 1900 || appObj.state.yob > new Date().getFullYear()) {
    yobError = "invalid year of birth";
  }
  else {
    appObj.setState({ age: new Date().getFullYear() - appObj.state.yob })
  }
  if (appObj.state.mob === "") {
    mobError = "Select the month of your birth";
  }
  if (appObj.state.school === "") {
    schoolError = "Invalid school";
  }
  if (appObj.state.croom === "") {
    croomError = "Invalid class room";
  }
  if (appObj.state.gender === "") {
    genderError = "Select an option";
  }
  const isValidPhoneNumber = validator.isMobilePhone(
    appObj.state.phoneNo,
    "en-IN"
  );
  if (!(appObj.state.phoneNo === "") && !isValidPhoneNumber) {
    phoneNoError = "invalid phone number";
  }
  if (
    !(appObj.state.email === "") &&
    !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(appObj.state.email)
  ) {
    emailError = "invalid email";
  }

  if (emailError || yobError || mobError || schoolError || croomError || phoneNoError || genderError || originError || mtError) {
    appObj.setState({
      emailError,
      yobError,
      mobError,
      schoolError,
      croomError,
      phoneNoError,
      genderError,
      originError,
      mtError,
    });
    return false;
  }
  appObj.setState({
    emailError,
    yobError,
    mobError,
    schoolError,
    croomError,
    phoneNoError,
    genderError,
    originError,
    mtError,
  });
  return true;
};

const validateLanguage = (appObj: App) => {
  let langError = "";
  if (appObj.state.language === "") {
    langError = "Select a language";
  }
  if (langError) {
    appObj.setState({ langError });
    return false;
  }
  appObj.setState({ langError });
  return true;
};

const joinPaths = (folders: Array<string | undefined>) => {
  let filePath = "/";
  folders.forEach((folder) => {
    filePath = filePath + folder + "/";
  });
  filePath = filePath + "Identity.jpg";
  return filePath;
};

export const writeMetaToFirestore = (appObj: App, subjectId: string) => {
  const docId = !!subjectId
    ? subjectId
    : firebase
      .firestore()
      .collection("users")
      .doc(appObj.state.providerId)
      .collection("subjects")
      .doc().id;

  appObj.setState({ subjectId: docId });
  let metaDataPromise = subjectInFirestore(appObj, docId)
    .then((isMetaFound) => {
      if (!isMetaFound) {
        firebase
          .firestore()
          .collection("users")
          .doc(appObj.state.providerId)
          .collection("subjects")
          .doc(docId)
          .set({
            name: appObj.state.name,
            yob: appObj.state.yob,
            mob: appObj.state.mob,
            school: appObj.state.school,
            croom: appObj.state.croom,
            age: new Date().getFullYear() - appObj.state.yob,
            gender: appObj.state.gender,
            phoneNo: appObj.state.phoneNo,
            email: appObj.state.email,
            origin: appObj.state.origin,
            mt: appObj.state.mt,
            subjectId: docId,
            durationRecorded: 0,
            recordingsRecorded: 0,
            createdTime: Date.now(),
            identification: appObj.state.identification,
          });
      }
      if (!!appObj.state.identification) {
        firebase
          .storage()
          .ref()
          .child(
            joinPaths([
              appObj.state.providerId,
              appObj.state.subjectId,
              "Identity",
            ])
          )
          .put(appObj.state.identification_file);
        firebase
          .firestore()
          .collection("users")
          .doc(appObj.state.providerId)
          .collection("subjects")
          .doc(docId)
          .update({ identification: appObj.state.identification });
      }
    })
    .then(() => {
      const langRef = firebase
        .firestore()
        .collection("users")
        .doc(appObj.state.providerId)
        .collection("subjects")
        .doc(docId)
        .collection("languages")
        .doc(appObj.state.language);

      langRef.get().then((docSnapshot) => {
        if (!docSnapshot.exists) {
          const sentenceId = Math.floor(Math.random() * 600);
          langRef
            .set({
              language: appObj.state.language,
              startingSentence: sentenceId,
              currentSentence: sentenceId,
              durationRecorded: 0,
              recordingsRecorded: 0,
            })
            .then(() =>
              langRef.get({ source: "server" }).then((docSnapshot) => {
                appObj.setState(
                  { langDocFirestore: docSnapshot, currentPage: "record" }
                );
              })
            ); // create the document
        } else {
          appObj.setState(
            { langDocFirestore: docSnapshot, currentPage: "record" }
          );
        }
      });
    });
  return metaDataPromise;
};

export const handleSubmit = (appObj: App, e: Event) => {
  e.preventDefault();
  let isValid = validate(appObj) || appObj.state.metaDataAvailable;
  const isValidLang = validateLanguage(appObj);

  if (
    appObj.state.isLoggedIn ||
    !!appObj.state.metaDataAvailable ||
    !appObj.state.anonId
  ) {
    if (isValid) {
      if (isValidLang) {
        writeMetaToFirestore(appObj, appObj.state.subjectId);
      }
    }
  } else {
    subjectInFirestore(appObj, appObj.state.anonId).then((anonUserExists) => {
      if (!!anonUserExists) {
        getMetaData("Anonymous", appObj.state.anonId).then((snapshot) => {
          appObj.setState(snapshot.data(), () =>
            appObj.setState({ metaDataAvailable: true })
          );
        });
      } else {
        alert(
          "Could not map you to an existing user in our database. Please re-enter the details"
        );
      }
    });
  }
};
export const handleChange = (appObj: App, e: any) => {

  if (e.target.id === "gender" || e.target.id === "language") {
    appObj.setState(
      {
        [e.target.id]:
          e.target.type !== "checkbox"
            ? e.target.value.toLowerCase()
            : e.target.checked,
      }
    );
  } else if (e.target.type === "file") {
    appObj.setState(
      {
        [e.target.id]: true,
        [e.target.id + "_file"]: e.target.files[0],
      }
    );
  } else {
    appObj.setState(
      {
        [e.target.id]:
          e.target.type !== "checkbox" ? e.target.value : e.target.checked,
      }
    );
  }
};

const subjectInFirestore = (appObj: App, subjectId: string) => {

  let foundPromise = firebase
    .firestore()
    .collection("users")
    .doc(appObj.state.providerId)
    .collection("subjects")
    .doc(subjectId)
    .get()
    .then((doc) => {
      let isMetaFound = false;
      if (doc.exists) {
        const { age }: any = doc.data();
        appObj.setState({ age });
        isMetaFound = true;
      } else {
        isMetaFound = false;
      }
      return isMetaFound;
      //this.getSentenceFromFirestore(lang, sentenceId);
    });
  return foundPromise;
};

const getDocs = (appObj: App) => {
  firebase
    .firestore()
    .collection("users")
    .doc(appObj.state.providerId)
    .collection("subjects")
    .get()
    .then((snapshot) => {
      let documents = snapshot.docs;
      appObj.setState({ docs: documents }
      );
    });
};

const getMetaData = (providerId: string, subjectId: string) => {
  return firebase
    .firestore()
    .collection("users")
    .doc(providerId)
    .collection("subjects")
    .doc(subjectId)
    .get();
};

export const handleSuccessfulToggle = (appObj: App) => {
  if (appObj.state.isSubProvider && appObj.state.isLoggedIn) {
    appObj.setState(
      {
        subjectId: appObj.state.providerId,
        name: firebase.auth().currentUser?.displayName,
      },
      () =>
        subjectInFirestore(appObj, appObj.state.subjectId).then((isMetaFound) =>
          appObj.setState({ metaDataAvailable: isMetaFound })
        )
    );

  } else {
    // TODO : Change this
    appObj.setState({ subjectId: "" });
    if (appObj.state.isExistingSubject) {
      getDocs(appObj);
    } else {
      // Can't do the auto-checking here overriding provider's input - So, always taking it as a new user
      appObj.setState({
        metaDataAvailable: false,
        subjectId: "",
        showModal: true,
      });
    }
  }
};

export const handleToggle = (appObj: App, e: any) => {
  if (!appObj.state.isLoggedIn) {
    alert("You need to login to choose this option");
    e.target.checked = false;
    return;
  }

  appObj.setState(
    {
      [e.target.id]:
        e.target.type !== "checkbox" ? e.target.value : e.target.checked,
    },
    () => handleSuccessfulToggle(appObj)
  );
};

export const clickExistingUser = (appObj: App, e: any) => {
  appObj.setState({
    subjectId: e.target.id,
    metaDataAvailable: true,
    language: "",
    name: e.target.getAttribute('subname'),//e.target.subname,
  });
};

export const unsetModal = (appObj: App, e: any) => {
  appObj.setState({ showModal: false });
};
